/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { cardLinkedStyle } from "./cardLinkedStyle";
import { Link } from "react-router";
import GradientCard from "../../GradientComponents/GradientCard";

type CardLinkedProps = {
  image: string;
  altTitle: string;
  headline: string;
  text: string;
  buttonText?: string;
  linkTo: string;
};
const CardLinked = ({ image, altTitle, headline, text, buttonText = "mehr lesen", linkTo }: CardLinkedProps) => {
  return (
    <GradientCard sx={cardLinkedStyle.card}>
      <CardActionArea component={Link} to={linkTo}>
        <CardMedia component="img" sx={cardLinkedStyle.media} image={image} title={altTitle} />
        <CardContent sx={cardLinkedStyle.teaserText}>
          <Typography gutterBottom variant="h5" sx={cardLinkedStyle.headline}>
            {headline}
          </Typography>
          <Typography component="p">{text}</Typography>
        </CardContent>
      </CardActionArea>
      <CardActions sx={cardLinkedStyle.cardActions}>
        {/* @ts-ignore (because 'buttonText' isn't recognized as color */}
        <Button color="buttonText" size="small" component={Link} to={linkTo}>
          {buttonText}
        </Button>
      </CardActions>
    </GradientCard>
  );
};

export default CardLinked;
